export type TableConfig = {
  showActions: boolean;
  enableContextMenu: boolean;
  allowCreateRecord: boolean;
  apiUrl: string;
  allowFeatureMigrate: boolean;
};
